import secondaryComponents from "../..";
import { useBillsItemsTable } from "./useBillsItemsTable";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../assets/svgImages";

export const BillsItemsTable = ({ billsItems = [], billsDetails = null }) => {
  const { instance } = useBillsItemsTable({
    billsItems,
    billsDetails,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div>
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={styles.billsItemsTable}
        >
          <div className="pt-5 text-center">
            <PurchaseOrderImage />
            <h4>You have no Bills</h4>
          </div>
        </secondaryComponents.TableHelper>
      </div>
    </>
  );
};
